import Image from "next/image";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import { HormoneSupportOtherContent } from "../../data/hormone-support-content";

const HormoneSupportOtherCard = ({ content }: { content: HormoneSupportOtherContent }) => {
    return (
        <div className="relative h-[520px] md:h-[550px] w-full overflow-hidden rounded-2xl bg-gray100 p-8 text-center text-gray500 md:px-6">
            <Reveal className="pointer-events-none absolute inset-0 md:hidden">
                <Image
                    src={content.mobileImage}
                    alt={content.imageAlt}
                    fill
                    sizes="100vw"
                    className="object-cover object-center"
                />
            </Reveal>

            <div className="relative flex h-full flex-col pb-0">
                <Paragraph
                    as="h3"
                    size="xl"
                    weight="500"
                    className="mt-auto text-[20px] md:mt-0 md:text-[26.5px] md:font-light md:leading-[1.1] md:tracking-[-0.265px]"
                >
                    {content.description}
                </Paragraph>

                <div className="relative mx-auto hidden h-[251px] w-full md:block mb-4">
                    <Image
                        src={content.desktopImage}
                        alt={content.imageAlt}
                        fill
                        sizes="33vw"
                        className="object-contain object-center"
                    />
                </div>

                <Heading
                    as="p"
                    size="xs"
                    weight="400"
                    className="order-first text-[24px] text-gray500 md:order-none mt-0 md:mt-auto md:text-[18px] md:font-medium "
                >
                    {content.heading}
                </Heading>

                <ul className="mt-2 md:mt-5">
                    {content.bullets.map((item) => (
                        <li key={item}>
                            <Paragraph size="md" sizes={{md:"lg"}}>{item}</Paragraph>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default HormoneSupportOtherCard;
